export class GameCommunicationBaseSender {
  name = '';

  dispatch(payload?: unknown): void {
    const event = new CustomEvent(`GameCommunicationSender-${this.name}`, { detail: payload });
    window.dispatchEvent(event);
  }
}
